"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ArrowUpSolid = function ArrowUpSolid() {
  return _react2.default.createElement(
    "g",
    { id: "arrow_up", transform: "translate(0.000000, 110.000000)" },
    _react2.default.createElement("polygon", { id: "Polygon_2_copy_3", points: "250 0 0 312.5 500 312.5" })
  );
};

exports.default = ArrowUpSolid;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-icon/Icons/ArrowUpSolid.js
// module id = 2926
// module chunks = 4